<template>
	<div class="binSlider">
		<div class="binSlider__custom-marks">
			<div class="binSlider__single-mark">
				<img :src="getBinAssetPath('dustbin-1.svg', 'icons')" />
				{{ marks.min }}
			</div>
			<vue-slider
				v-model="value"
				class="binSlider__wrapper"
				:width="'100%'"
				:key="updater"
				:enable-cross="false"
				:tooltip="'always'"
				:min="effectiveMin"
				:max="effectiveMax"
				:event-type="isMobile || isTablet ? 'touch' : 'mouse'"
				:interval="effectiveInterval"
			>
				<template #dot>
					<div class="binSlider__dot" />
				</template>
				<template #tooltip="{ value }">
					<div class="vue-slider-dot-tooltip-inner vue-slider-dot-tooltip-inner-top">
						<div class="binSlider__custom-tooltip">
							<div class="binSlider__custom-tooltip--value">
								{{ tooltipValue(value) }}
							</div>
						</div>
					</div>
				</template>
			</vue-slider>
			<div class="binSlider__single-mark">
				<img :src="getBinAssetPath('dustbin-3.svg', 'icons')" />
				{{ marks.max }}
			</div>
		</div>
	</div>
</template>


<script src="./FormulateBinSlider.js"></script>
